<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Inicialização</h1>
        <paragrafo>
          <negrito>Configurações iniciais</negrito>
        </paragrafo>
        <li>
          Inicialização do equipamento no botão da lateral esquerda. Segure para
          ligar/desligar;
        </li>
        <li>
          Verificar conexão wifi/dados móveis ao arrastar a barra superior da
          tela inicial;
        </li>
        <li>
          Botões parte inferior da tela: Voltar, Tela inicial e Mostrar apps
          abertos;
        </li>
        <li>
          Caso necessite durante a operação, no ícone de configurações é
          possível determinar o tempo que a tela fica ligada em: Tela/Modo de
          espera.
        </li>
        <v-row justify="center" class="mt-5">
          <imagem :src="image_1" />
        </v-row>
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "inicializacao",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem_pos.vue"),
    negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_1: "/pos/imagensPOS/telainicial.png",
    };
  },
};
</script>
